import { render, staticRenderFns } from "./backDataAccByCanteen.vue?vue&type=template&id=351d8489&scoped=true&"
import script from "./backDataAccByCanteen.vue?vue&type=script&lang=js&"
export * from "./backDataAccByCanteen.vue?vue&type=script&lang=js&"
import style0 from "./backDataAccByCanteen.vue?vue&type=style&index=0&id=351d8489&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351d8489",
  null
  
)

export default component.exports